import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  savedMessagesKey,
  errorMessage,
} from '@features/savedMessages';
import axiosInstance from '@server/axiosInstance';
import { tampleteSavedMessagesRoute } from '../api/constants';

type useDeleteTemplateSavedMessageProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useDeleteTemplateSavedMessage = ({
  setErrorText = () => { },
}: useDeleteTemplateSavedMessageProps) => {
  const client = useQueryClient();

  const { mutate: deleteSavedMessage, isLoading: isDeletingSavedMessage } =
    useMutation({
      mutationFn: (variables:
        {
          saved_message_id: number
          etemplate_id: number
        }) =>
        axiosInstance
          .delete(tampleteSavedMessagesRoute, { data: variables })
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          setErrorText('');
          client.invalidateQueries([savedMessagesKey]);
        }
      },
      onError: (error: { message?: string }) => {
        setErrorText(error?.message || errorMessage);
      },
    });

  return {
    deleteSavedMessage,
    isDeletingSavedMessage,
  };
};
